import { StateFormProvider } from "./useStateFormStore";
import StateFormView from "./StateFormView";

const StateForm = ({ item, parentId, onUpdate, validated, useStore, section, lineId, path, onClose }) => {


    return (
        <StateFormProvider>
            <StateFormView
                item={item}
                parentId={parentId}
                onUpdate={onUpdate}
                validated={validated}
                useStore={useStore}
                section={section}
                lineId={lineId}
                path={path}
                onClose={onClose}
            />
        </StateFormProvider>
    )
}

export default StateForm;